export enum Role {
  MANAGER = 'manager',
}

export interface User {
  id: string;
  email: string;
  name: string;
  role: Role;
  company_name?: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  name: string;
  email: string;
  password: string;
  company_name: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  new_password: string;
}

export interface AuthResponse {
  access_token: string;
  refresh_token: string;
  user: User;
}
